<template>
  <transition name="modal-outer">
    <section
      v-if="open"
      @click="dismiss"
      class="absolute bg-gray-800/80 flex flex-col top-0 left-0 h-full min-h-screen w-screen overflow-x-hidden overflow-y-auto z-20 px-6 py-8"
    >
      <transition name="modal-inner">
        <card
          padding=""
          v-show="open"
          @click.stop
          @keyup.esc="dismiss"
          class="flex flex-col top-0 left-0 m-auto z-30 transition-all ease-linear delay-150 w-full"
          :class="[{ stretch: stretchModal }, size]"
        >
          <div class="border-b border-gray-500/20" v-if="header || validSlot('header')">
            <slot name="header">
              <div class="font-bold text-xl p-4">
                {{ header }}
              </div>
            </slot>
          </div>

          <section class="flex flex-col gap-2" :class="padding">
            <section v-if="validSlot('default')" :class="class">
              <slot></slot>
            </section>
            <section v-if="validSlot('buttons')" class="flex flex-row justify-center gap-6">
              <rpm-button
                v-if="!noCancelButton"
                color="gray"
                :label="cancelButtonLabel"
                @click="$emit('close')"
              ></rpm-button>

              <slot name="buttons"></slot>
            </section>
          </section>
        </card>
      </transition>
    </section>
  </transition>
</template>


<script>

export default {
  name: "RpmModal",
  data() {
    return {
      stretchModal: false,
      stretchTimer: null
    };
  },
  props: {
    class: {
      type: String,
      default: "",
    },
    header: {
      type: String,
      default: "",
    },
    padding: {
      type: String,
      default: "p-8",
    },
    open: {
      type: Boolean,
      default: false,
    },
    persist: {
      type: Boolean,
      default: false,
    },
    noCancelButton: {
      type: Boolean,
      default: false,
    },
    cancelButtonLabel: {
      type: String,
      default: "Cancelar",
    },
    size: {
      type: String,
      default: "max-w-5xl",
    }
  },
  methods: {
    dismiss() {
      if (this.persist) {
        this.stretchModal = true;

        clearTimeout(this.stretchTimer);
        this.stretchTimer = setTimeout(() => {this.stretchModal = false;}, 500);

      } else this.$emit("close");
    },
    validSlot(slot) {
      return !!this.$slots[slot];
    },
  },
};
</script>

<style scoped>
.modal-outer-enter-active,
.modal-outer-leave-active {
  transition: opacity 0.15s ease-out;
}

.modal-outer-enter-from,
.modal-outer-leave-to {
  opacity: 0;
}

.modal-inner-enter-active {
  transition: all 0.15s ease-out 0.1s;
}

.modal-inner-leave-active {
  transition: all 0.15s ease-out;
}

.modal-inner-enter-from {
  opacity: 0;
  transform: scale(0.8);
}

.modal-inner-leave-to {
  transform: scale(0.8);
}
</style>
